import { render, staticRenderFns } from "./CarteiraVacinacaoTable.vue?vue&type=template&id=fbe129ee&scoped=true&"
import script from "./CarteiraVacinacaoTable.vue?vue&type=script&lang=js&"
export * from "./CarteiraVacinacaoTable.vue?vue&type=script&lang=js&"
import style0 from "./CarteiraVacinacaoTable.vue?vue&type=style&index=0&id=fbe129ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe129ee",
  null
  
)

export default component.exports